import { messages } from './service-mode-messages';

export const getCateringPickupMessage = (formatMessage: Function, storeAddress: string) =>
  `${formatMessage(messages.cateringPickUpAt)}  ${storeAddress}`;
